import { gql } from "@apollo/client";

export const CREATE_CUSTOMER_ADDRESS = gql`
  mutation CreateCustomerAddressMutation($input: CreateCustomerAddressInput!) {
    createCustomerAddress(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CUSTOMER_ADDRESS = gql`
  mutation UpdateCustomerAddressMutation($id: Int!, $input: UpdateCustomerAddressInput!) {
    updateCustomerAddress(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const UPDATE_CUSTOMER_ADDRESS_LOCATION = gql`
  mutation UpdateCustomerAddressLocationMutation(
    $id: Int!
    $input: UpdateCustomerAddressLocationInput!
  ) {
    updateCustomerAddressLocation(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_CUSTOMER_ADDRESS = gql`
  mutation RemoveCustomerAddressMutation($id: Int!) {
    removeCustomerAddress(id: $id) {
      ok
      error
    }
  }
`;

export const CUSTOMER_ADDRESS = gql`
  query CustomerAddressQuery($id: Int!) {
    customerAddress(id: $id) {
      ok
      error
      result {
        id
        type
        label
        street
        city
        postal
        lat
        lng
        isMain
        active
        customer {
          id
          name
        }
      }
    }
  }
`;

export const CUSTOMER_ADDRESSES = gql`
  query CustomerAddressesQuery($where: CustomerAddressesFiltersInput!) {
    customerAddresses(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        type
        label
        street
        city
        postal
        lat
        lng
        isMain
        active
      }
    }
  }
`;
